import React, { useState, useEffect } from 'react';

import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import Header from 'on_web/components/shared/Menu/Header/Header';
import ReportsBottomNavigation from 'on_web/components/shared/ReportsBottomNavigation/ReportsBottomNavigation';
import PageItemContainer from 'on_web/components/shared/Common/PageItemContainer/PageItemContainer';
import TraitGroupsMenu from 'on_web/components/shared/TraitGroupsMenu/TraitGroupsMenu';
import ReportsSectionTitleWithBackground from 'on_web/components/shared/ReportsSectionTitleWithBackground/ReportsSectionTitleWithBackground';
import DesktopMenu from 'on_web/components/shared/Menu/DesktopMenu/DesktopMenu';

import { useTranslation } from 'react-i18next';

import { traitsHeaderBackground } from 'on_web/assets/imageList';
import {
  getComorbiditiesMenuItems,
  getRiskForComorbidity,
  hasPrevious,
  hasPreviousGroup,
  hasNextGroup,
  hasNext,
  getNextTrait,
  getNextGroup,
  getPreviousGroup,
  getPreviousTrait,
  getCurrentTraitIndex,
  getComorbiditiesMenuItemIndex,
  getComorbidityGroupCodeByMenuIndex,
} from 'on_web/helpers/menuItems';

import { reportsBottomNavigationOptions } from 'on_web/helpers/redirectHelper';
import ReportsOpenTextSection from 'on_web/components/shared/ReportsOpenTextSection/ReportsOpenTextSection';

import {
  riskExistComorbidity,
  noRiskComorbidity,
} from 'on_web/assets/imageList';

import { makeStyles } from '@material-ui/core/styles';
import { ROUTE_ASSESSMENT_HEALTH_RISKS_GROUPS } from 'routes';
import { trackEvent } from 'on_web/helpers/userTrackingEventsHelper';
import useCheckScreenSize from 'on_web/hooks/useCheckScreenSize';
import useUsersApi from 'on_web/hooks/useUsersApi';

import {
  getHealthRisks,
  healthRiskGroups,
  parseHealthRisks,
  parseLikelihood,
} from 'on_web/helpers/risksHelper';

export default function ReportsComorbidityDetails(props) {
  const [isDesktop] = useCheckScreenSize();
  const [menuTitle, setMenuTitle] = useState(
    props.location.state && props.location.state.menuTitle
      ? props.location.state.menuTitle
      : ''
  );

  const useStyles = makeStyles(theme => ({
    text: {
      fontSize: '25px',
      fontFamily: 'Museo',
      fontWeight: 'bold',
    },
  }));

  const { t } = useTranslation();

  const [currentComorbidityCode, setCurrentComorbidityCode] = useState(
    props.location.state.comorbidityCode
  );
  const [
    currentComorbidityGroupCode,
    setCurrentComorbidityGroupCode,
  ] = useState(props.location.state.comorbidityGroupCode);
  const [
    currentComorbidityGroupCodeIx,
    setCurrentComorbidityGroupCodeIx,
  ] = useState(getComorbiditiesMenuItemIndex(currentComorbidityGroupCode));

  const [{ getSpareAssessments }] = useUsersApi();
  const [responseHealthBasedRisks, setResponseHealthBasedRisks] = useState(
    null
  );
  const [healthBasedRisksObj, setHealthBasedRisksObj] = useState(null);
  const [likelihoodObj, setLikelihoodObj] = useState(null);
  const [responseLikelihood, setResponseLikelihood] = useState(null);

  useEffect(() => {
    if (
      props.location.state &&
      props.location.state.healthBasedRisks &&
      props.location.state.infectionLikelihood
    ) {
      setResponseHealthBasedRisks(props.location.state.healthBasedRisks);
      setHealthBasedRisksObj(
        parseHealthRisks(props.location.state.healthBasedRisks)
      );
      setResponseLikelihood(props.location.state.infectionLikelihood);
      setLikelihoodObj(
        parseLikelihood(props.location.state.infectionLikelihood, t)
      );
    } else {
      getSpareAssessments().then(resp => {
        setResponseHealthBasedRisks(resp.health_based_severity);
        setHealthBasedRisksObj(parseHealthRisks(resp.health_based_severity));
        setResponseLikelihood(resp.past_infection_likelihood);
        setLikelihoodObj(parseLikelihood(resp.past_infection_likelihood, t));
      });
    }
  }, [getSpareAssessments]);

  const getAllComorbidities = comorbidityGroupCode => {
    let allComorbidities = [];

    if (responseHealthBasedRisks) {
      const risks = responseHealthBasedRisks.groups.find(
        g => g.code === comorbidityGroupCode
      ).risks;

      responseHealthBasedRisks.risks.forEach(r => {
        if (risks.includes(r.risk.code)) {
          allComorbidities.push({
            code: r.risk.code,
            name: r.risk.name,
          });
        }
      });
    }

    return allComorbidities;
  };

  const hasNextPage = () => {
    return hasNextElementInGroup() || hasNextTraitGroup();
  };

  const onClickRightArrow = () => {
    trackEvent('Reporting', 'Navigate to previous comorbidity click');
    setMenuTitle(
      'reporting.common.comorbiditiesCategories.individual_condition'
    );
    let nextComorbiditiesGroup = getNextGroup(currentComorbidityGroupCodeIx);
    let firstElementNextGroup = getAllComorbidities(
      nextComorbiditiesGroup.code
    )[0];
    let nextGroupIndex = getComorbiditiesMenuItemIndex(
      nextComorbiditiesGroup.code
    );

    if (hasNextTraitGroup() && !hasNextElementInGroup()) {
      setCurrentComorbidityGroupCode(nextComorbiditiesGroup.code);
      setCurrentComorbidityCode(firstElementNextGroup.code);
      setCurrentComorbidityGroupCodeIx(nextGroupIndex);
    } else {
      setCurrentComorbidityCode(
        getNextTrait(
          currentComorbidityCode,
          getAllComorbidities(currentComorbidityGroupCode)
        ).code
      );
    }
  };

  const hasNextElementInGroup = () => {
    let allComorbiditiesArray = getAllComorbidities(
      currentComorbidityGroupCode
    );
    let currentIndex = getCurrentTraitIndex(
      currentComorbidityCode,
      allComorbiditiesArray
    );

    return hasNext(currentIndex, allComorbiditiesArray);
  };

  const hasNextTraitGroup = () => {
    let allGroupsArray = getComorbiditiesMenuItems();

    return hasNextGroup(currentComorbidityGroupCode, allGroupsArray);
  };

  const onClickLeftArrow = () => {
    trackEvent('Reporting', 'Navigate to next comorbidity click');
    setMenuTitle(
      'reporting.common.comorbiditiesCategories.individual_condition'
    );
    let previousComorbiditiesGroup = getPreviousGroup(
      currentComorbidityGroupCodeIx
    );
    let previousComorbiditiesArray =
      previousComorbiditiesGroup &&
      getAllComorbidities(previousComorbiditiesGroup.code);

    let lastElementPreviousGroup =
      previousComorbiditiesGroup &&
      previousComorbiditiesArray[previousComorbiditiesArray.length - 1];

    let previousGroupIndex =
      previousComorbiditiesGroup &&
      getComorbiditiesMenuItemIndex(previousComorbiditiesGroup.code);

    if (hasPreviousTraitGroup() && !hasPreviousElementInGroup()) {
      setCurrentComorbidityGroupCode(previousComorbiditiesGroup.code);
      setCurrentComorbidityCode(lastElementPreviousGroup.code);
      setCurrentComorbidityGroupCodeIx(previousGroupIndex);
    } else {
      setCurrentComorbidityCode(
        getPreviousTrait(
          currentComorbidityCode,
          getAllComorbidities(currentComorbidityGroupCode)
        ).code
      );
    }
  };

  const hasPreviousPage = () => {
    return hasPreviousElementInGroup() || hasPreviousTraitGroup();
  };

  const hasPreviousElementInGroup = () => {
    let allComorbiditiesArray = getAllComorbidities(
      currentComorbidityGroupCode
    );
    let currentIndex = getCurrentTraitIndex(
      currentComorbidityCode,
      allComorbiditiesArray
    );

    return hasPrevious(currentIndex, allComorbiditiesArray);
  };

  const hasPreviousTraitGroup = () => {
    return hasPreviousGroup(currentComorbidityGroupCode);
  };

  const onIconClicked = ix => {
    const code = getComorbidityGroupCodeByMenuIndex(ix);
    trackEvent('Reporting', `Navigate to comorbidity group ${code}`);
    props.history.push({
      pathname: ROUTE_ASSESSMENT_HEALTH_RISKS_GROUPS,
      state: {
        group: code,
        ...getStateToTransfer(),
      },
    });
  };

  const classes = useStyles();

  const getStateToTransfer = () => {
    return {
      healthBasedRisks: responseHealthBasedRisks,
      infectionLikelihood: responseLikelihood,
    };
  };

  const risk = responseHealthBasedRisks
    ? responseHealthBasedRisks.risks.find(
        r => r.risk.code === currentComorbidityCode
      )
    : null;

  return (
    <React.Fragment>
      <div style={{ display: 'flex' }}>
        <Grid
          container={useMediaQuery('(min-width:1000px)')}
          direction="row"
          justify="center"
          alignItems="center"
        >
          <PageItemContainer>
            <AppBar position="sticky">
              {isDesktop === false && (
                <Header
                  squeeze
                  title={
                    menuTitle !== ''
                      ? t(menuTitle)
                      : t(
                          'reporting.common.comorbiditiesCategories.individual_condition'
                        )
                  }
                  backToTopLvl={
                    getAllComorbidities(currentComorbidityGroupCode).length == 1
                  }
                  selectedGroupCode={
                    getComorbiditiesMenuItems()[currentComorbidityGroupCodeIx]
                      .code
                  }
                  secondaryHeaderWithBackNavigation
                />
              )}
              <AppBar position="sticky">
                {responseHealthBasedRisks && (
                  <TraitGroupsMenu
                    selIx={currentComorbidityGroupCodeIx}
                    items={getComorbiditiesMenuItems()}
                    groups={responseHealthBasedRisks.groups}
                    onIconClicked={ix => onIconClicked(ix)}
                  />
                )}
              </AppBar>
            </AppBar>

            {responseHealthBasedRisks && risk && (
              <ReportsSectionTitleWithBackground
                backgroundImage={traitsHeaderBackground}
                title={risk.risk.name}
                showLeftArrow={hasPreviousPage()}
                replaceLeftArrow={true}
                showRightArrow={hasNextPage()}
                replaceRightArrow={true}
                onClickRight={() => onClickRightArrow()}
                onClickLeft={() => onClickLeftArrow()}
              />
            )}

            <Box pt={'11px'} px={'20px'}>
              <Grid
                container
                direction="column"
                justify="center"
                alignItems="center"
              >
                <Grid item>
                  {risk && (
                    <img
                      alt="risk"
                      src={
                        currentComorbidityCode === 'age_covid_19_risk'
                          ? risk.level > 2
                            ? riskExistComorbidity
                            : noRiskComorbidity
                          : risk.level > 0
                          ? riskExistComorbidity
                          : noRiskComorbidity
                      }
                      width={72}
                    />
                  )}
                </Grid>
                <Grid item>
                  {risk && (
                    <Box textAlign="center" className={classes.text}>
                      {currentComorbidityCode === 'age_covid_19_risk'
                        ? 'Your age-related risk is ' +
                          risk.level_label.toLowerCase()
                        : risk.level > 0
                        ? t(
                            'reporting.common.comorbiditiesCategories.riskFactorHaving'
                          )
                        : t(
                            'reporting.common.comorbiditiesCategories.riskFactorNotHaving'
                          )}
                    </Box>
                  )}
                </Grid>
              </Grid>
            </Box>

            <Box
              mt={'16px'}
              pt={'16px'}
              mb={isDesktop ? '0' : '60px'}
              style={{
                borderTop: '1px Solid #efefef',
              }}
            >
              {risk && (
                <ReportsOpenTextSection
                  title={t(
                    'reporting.comorbiditiesDetails.comorbidityDescriptionSectionTitle'
                  ).toUpperCase()}
                  paragraphsKeys={[risk.risk.description]}
                />
              )}
            </Box>
            <ReportsBottomNavigation
              selected={reportsBottomNavigationOptions.healthRisk}
              onSelected={val =>
                props.history.push({
                  pathname: val,
                  state: getStateToTransfer(),
                })
              }
            />
          </PageItemContainer>
        </Grid>
      </div>
    </React.Fragment>
  );
}
